import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../../constants';
import { useAdUnit } from '../../useAdUnit';
const DesktopProfileTopDisplay728x90 = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Gak, ADUNIT_MAP['DesktopProfileTopDisplay728x90'], safety, {
        refreshLimit: 30,
        refreshTimeout: 30000,
        size: [
            728,
            90
        ]
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
DesktopProfileTopDisplay728x90.displayName = 'DesktopProfileTopDisplay728x90';
export default DesktopProfileTopDisplay728x90;
